import script from "./bannerHero.vue?vue&type=script&setup=true&lang=js"
export * from "./bannerHero.vue?vue&type=script&setup=true&lang=js"

import "./bannerHero.vue?vue&type=style&index=0&id=c6ebd8ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c6ebd8ca"]])

export default __exports__